<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableCbsResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.TENCENT.CBS.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.diskId"),
          key: "diskId"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.diskName"),
          key: "diskName"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.region"),
          key: "regionName"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.diskType"),
          key: "diskType"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.diskSize"),
          key: "diskSize"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.stateName"),
          key: "stateName"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.TENCENT.CBS.createdTime"),
          key: "createdTime"
        }
      ],
      tableData: []
    };
  },
  created() {
    this._handleCompanyId = val => { this.companyId = val; };
    this._handleAccountSearchKey = val => { this.accountSearchKey = val; };
    this._handleAccountName = val => { this.accountName = val; };
    this._handleDiskId = val => { this.diskId = val; };
    eventBus.$on("companyId", this._handleCompanyId);
    eventBus.$on("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$on("accountName", this._handleAccountName);
    eventBus.$on("diskId", this._handleDiskId);
    self = this;
  },
  methods: {
    showAll() {
      self.current = 1;
      self.getData();
    },
    getData() {
      self.$api.resourceManagement
        .selectTencentCbsByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          diskId: self.diskId,
          accountIdList: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    }
  },
  beforeDestroy() {
    eventBus.$off("companyId", this._handleCompanyId);
    eventBus.$off("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$off("accountName", this._handleAccountName);
    eventBus.$off("diskId", this._handleDiskId);
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/cbs/TableCbsResource.vue